import log from 'salvo-lite/log'

class InViewport {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elemA = document.querySelectorAll('.animate')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._checkStatus()

        // Listen for the scroll event
        document.addEventListener('scroll', () => {
            this._checkStatus()
        })
    }
    _checkStatus () {
        this._elemA.forEach((element) => {
            // Check the viewport status
            if (this._inViewport(element)) {
                element.classList.add('in-viewport')
            }
        })
    }
    _inViewport (element) {
        // Get the elements position relative to the viewport
        var bb = element.getBoundingClientRect()

        // Check if the element is outside the viewport
        // Then invert the returned value because you want to know the opposite
        // return !(bb.top > innerHeight || bb.bottom < 0)
        return !(bb.top > (innerHeight - (innerHeight / 4)) || bb.bottom < (0 + (innerHeight / 4)))
    }
}

export default InViewport



// WEBPACK FOOTER //
// ./src/resources/scripts/components/InViewport.js